// Load Styles
import '../scss/flixx.scss';

// Load Bootstrap init
import {initHelpers} from "./components/helpers.js";
import {initScrollAndView} from "./components/scroll_and_view.js";
import {initBootstrap} from "./components/bootstrap.js";
import {initLinks} from "./components/links.js";
import {initNavigation} from "./components/flixx_navigation.js";
import {initJobs} from "./components/flixx_jobs.js";
import {initNetwork} from "./components/flixx_network.js";
import {initNews} from "./components/flixx_news.js";
import {initProducts} from "./components/flixx_products.js";
import {initEvents} from "./components/flixx_events.js";
import {initModals} from "./components/modals.js";
import {initMap} from "./components/map.js"; // Keep it here, will load via Google Maps callback

$(document).ready(function () {
  initHelpers();
  initScrollAndView();
  initBootstrap();
  initLinks();
  initNavigation();
  initJobs();
  initNetwork();
  initNews();
  initProducts();
  initEvents();
  initModals();

  /**
   * Lazy Loading Images
   */
  $('.lazy').lazy();

});

let delay = function (time = 0) {
  return new Promise(resolve => setTimeout(resolve, time));
}

$(window).resize(async function () {
  //await delay(300);

});


